import { render } from "./ExpandTransition.vue?vue&type=template&id=78e953bd&scoped=true"
import script from "./ExpandTransition.vue?vue&type=script&lang=js"
export * from "./ExpandTransition.vue?vue&type=script&lang=js"

import "./ExpandTransition.vue?vue&type=style&index=0&id=78e953bd&scoped=true&lang=css"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e953bd"]])

export default __exports__